import { createDeepEqual } from '../../../js-utils/src/createDeepEqual.mjs';

const deepEqual = createDeepEqual();

export { deepEqual };
//# sourceMappingURL=deepEqual.mjs.map
